import React from 'react';
import { Link } from 'react-router-dom';
import { EARLY_ACCESS_PATH } from '../../domain/earlyAccessSignup';
import { trackEarlyAccessCtaClick } from '../../utils/enhancedAnalytics';
import './EarlyAccessCallout.css';

export default function EarlyAccessCallout({ page, placement }) {
  return (
    <aside
      className="ab-ea-callout"
      data-testid="early-access-callout"
      data-placement={placement}
      aria-label="LiveScope Builder early access"
    >
      <div className="ab-ea-callout-inner">
        <p className="ab-ea-callout-kicker">Coming to Angler Built</p>
        <h2 className="ab-ea-callout-title">LiveScope Builder is coming</h2>
        <p className="ab-ea-callout-body">Get notified when the beta opens.</p>
        <Link
          className="ab-ea-callout-cta"
          to={EARLY_ACCESS_PATH}
          data-testid="early-access-callout-cta"
          onClick={() => {
            trackEarlyAccessCtaClick({ page, placement });
          }}
        >
          Join early access
        </Link>
      </div>
    </aside>
  );
}
